/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import {
  deleteMandateFileById,
  downloadMandateFileById,
  fetchMandateFileByMandateId,
  uploadMandateFile
} from '../../lib/rest/mandateFileAPIClient'
import FileInput, { FileInputProps } from '../inputs/FileInput'
import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { useSettingsContext } from '../SettingsProvider'

export type MandateFileFieldProps =
  Omit<FileInputProps, 'onDownload' | 'onDelete' | 'onChange' | 'onUpload'>
  & {
  mandateId?: number,
  // tmpRef: string
}

function MandateFileField (props: MandateFileFieldProps) {
  const { mandateId, ...others } = props

  const { settings } = useSettingsContext()

  const loader = useQuery({
    enabled: mandateId > 0,
    queryKey: ['mandateFile', mandateId],
    queryFn: () => fetchMandateFileByMandateId(mandateId),
    refetchOnWindowFocus: false
  })
  const { data: file } = loader
  const fileId = file?.id

  const downloadFunction = useCallback(() => downloadMandateFileById(fileId), [fileId])
  const deleteFunction = useCallback(() => deleteMandateFileById(fileId), [fileId])
  const uploadFunction = useCallback((file1: File) => uploadMandateFile(file1, mandateId), [mandateId])

  return (
    <FileInput
      {...others}
      accept={settings.MANDATE_FILE_TYPES}
      maxSize={settings.MANDATE_MAX_UPLOAD_SIZE}
      name="mandate_file"
      onDownload={downloadFunction}
      onDelete={deleteFunction}
      onChange={() => loader.refetch()}
      onUpload={uploadFunction}
      value={file?.name}
      lastModified={file?.createdAt}
      contentLength={file?.size}
    />
  )
}

export default MandateFileField
